
export function getNowTime(UTC) {
  if (UTC) {
    return (UTC + '').replace(/T/, ' ')
  } else {
    return ''
  }
  // if (!UTC) {
  //   return ''
  // } else {
  //   return new Date(parseInt(new Date(UTC).getTime()) + (8 * 60 * 60 * 1000)).toLocaleString('chinese', { hour12: false }).replace(/\//g, '-').replace(/[\u4e00-\u9fa5]/g, '')
  // }
}



// WEBPACK FOOTER //
// ./src/filter/index.js